import CustomCard from '@/components/customCard';
import RegularText from '@/components/RegularText';
import React from 'react';
import { Button, CardProps, Tooltip } from '@shopify/polaris';
import { ButtonImageVerticalStyled } from '@/components/ButtonImageVertical/styled';
import { XIcon } from '@shopify/polaris-icons';

interface IProps {
  icon?: React.ReactElement;
  title?: string;
  onClick?: () => void;
  children?: React.ReactElement | string;
  disabled?: boolean;
  tooltip?: React.ReactNode;
  selected?: boolean;
  padding?: CardProps['padding'];
  isShowRemove?: boolean;
}

const ButtonImageVertical = (props: IProps) => {
  const content = (
    <CustomCard
      padding={props.padding}
      title={
        <div>
          <div className="mb-16 mt-16 text-center">{props.title}</div>
          <div className="card-icon">{props.icon}</div>
        </div>
      }
      style={{ position: 'relative' }}
    >
      {props.isShowRemove && (
        <div className="remove-container">
          <Button icon={XIcon}>Remove</Button>
        </div>
      )}
      <RegularText>{props.children}</RegularText>
    </CustomCard>
  );

  return (
    <ButtonImageVerticalStyled
      className="mt-8 card-container"
      onClick={props.disabled ? undefined : props.onClick}
      disabled={props.disabled}
      selected={props.selected}
    >
      {props.tooltip ? <Tooltip content={props.tooltip}>{content}</Tooltip> : content}
    </ButtonImageVerticalStyled>
  );
};

export default ButtonImageVertical;
